'use client'

import { useEffect } from 'react';
import Link from 'next/link';

// Catches errors in the root layout — must wrap <html> itself.
export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error(
            JSON.stringify({
                level: 'error',
                timestamp: new Date().toISOString(),
                service: 'carjunction-web',
                type: 'global_error',
                message: error.message,
                digest: error.digest,
                stack: error.stack,
            }),
        );
    }, [error]);

    return (
        <html lang="en">
            <body>
                <div className="flex min-h-screen flex-col items-center justify-center px-4">
                    <div className="max-w-md w-full p-8 text-center">
                        <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong!</h2>
                        <p className="text-gray-600 mb-6">
                            A critical error occurred. Please try again or return to the home page.
                        </p>
                        <div className="flex gap-4 justify-center">
                            <button
                                onClick={reset}
                                className="px-5 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
                            >
                                Try Again
                            </button>
                            <Link
                                href="/"
                                className="px-5 py-2 rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
                                prefetch={false}
                            >
                                Go Home
                            </Link>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    );
}
